"use client";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { MdArrowRightAlt } from "react-icons/md";

export default function PostListItem({ post }) {
  const unformattedPostURL = post.attributes.title;
  const formattedPostURL = unformattedPostURL.replace(/ /g, "-");
  return (
    <div className="blog-post-list-item">
      <div className="blog-post-list-item-image">
        {post.attributes.main_image && post.attributes.main_image.data && (
          <Image
            src={post.attributes.main_image.data.attributes.url}
            width={1920}
            height={1080}
            alt="cta-card-31"
          />
        )}
      </div>
      <div className="blog-post-tags">
        {post.attributes.tags.map((tag, index) => (
          <div className="tag" key={index}>
            {tag.tag}
          </div>
        ))}
      </div>

      <div className="blog-post-list-item-content">
        <div className="blog-post-list-item-date">{post.attributes.date}</div>

        <span className="blog-post-list-item-title">
          {post.attributes.title}
        </span>
        {post.attributes.description && (
          <span className="blog-post-list-item-description">
            {/* If card_description is overflowing add ... at the end. Add at last finished whole word in sentence*/}
            {post.attributes.card_description.length > 100
              ? post.attributes.card_description
                .substring(0, 100)
                .replace(/\s+\S*$/, "...")
              : post.attributes.card_description}
          </span>
        )}
      </div>
      <div className="blog-post-call-to-action">
        <Link href={`/blog/${formattedPostURL}`}>
          Read Article <MdArrowRightAlt />
        </Link>
      </div>
    </div>
  );
}
